import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { RoleService } from '@core/services/role.service';
import { map, Observable, take } from 'rxjs';

/**
 * 只有系統管理者進得去。
 *
 * authGuard 只確認「有登入」，擋不住直接打 URL；側欄把入口藏起來也只是視覺上的，
 * 後台頁改的是全站設定，不能只靠選單看不到來保護。
 *
 * 等第一筆角色資料到齊才放行，因此在 authGuard 之後（父路由先跑）才有意義：
 * 未登入時 RoleService.roles$ 不會發值。
 */
export const adminGuard =
  (redirectTo: string): CanActivateFn =>
  (): Observable<boolean | UrlTree> => {
    const roleService = inject(RoleService);
    const router = inject(Router);
    return roleService.isAdmin().pipe(
      take(1),
      map((isAdmin) => isAdmin || router.parseUrl(redirectTo))
    );
  };
